// Helper to prepare playground payloads and open the playground
export function normalizePlaygroundLanguage(lang = '') {
  const value = String(lang || '').trim().toLowerCase();
  const map = {
    js: 'javascript',
    javascript: 'javascript',
    var: 'javascript',
    let: 'javascript',
    const: 'javascript',
    html: 'html',
    markup: 'html',
    xml: 'html',
    css: 'css',
    py: 'python',
    python: 'python',
    php: 'php',
    c: 'cpp',
    cpp: 'cpp',
    java: 'java',
    csharp: 'csharp',
    cs: 'csharp',
    go: 'go',
    golang: 'go',
    rust: 'rust',
    dart: 'dart',
    plaintext: 'text',
    text: 'text'
  };

  return map[value] || value || 'text';
}

export function preparePlayground({ html, css, js, py, php, code, lang } = {}) {
  if (typeof window === 'undefined') return;
  try {
    // Clear preview keys
    sessionStorage.removeItem('preview:incomingSrcDoc');
    sessionStorage.removeItem('preview:incomingTitle');

    // Clear existing playground keys
    sessionStorage.removeItem('playground:incomingHtml');
    sessionStorage.removeItem('playground:incomingCss');
    sessionStorage.removeItem('playground:incomingJs');
    sessionStorage.removeItem('playground:incomingPy');
    sessionStorage.removeItem('playground:incomingPhp');
    sessionStorage.removeItem('playground:incomingCode');
    sessionStorage.removeItem('playground:incomingLang');

    if (html || css || js || py || php) {
      if (html) sessionStorage.setItem('playground:incomingHtml', html);
      if (css) sessionStorage.setItem('playground:incomingCss', css);
      if (js) sessionStorage.setItem('playground:incomingJs', js);
      if (py) sessionStorage.setItem('playground:incomingPy', py);
      if (php) sessionStorage.setItem('playground:incomingPhp', php);
      return;
    }

    if (code) {
      sessionStorage.setItem('playground:incomingCode', code);
      if (lang) sessionStorage.setItem('playground:incomingLang', normalizePlaygroundLanguage(lang));
    }
  } catch (e) {
    // ignore
  }
}

export function openPlayground(newTab = true) {
  if (typeof window === 'undefined') return;
  if (newTab) window.open('/playground', '_blank');
  else window.location.href = '/playground';
}

export function goToPlaygroundWith(payload = {}, newTab = true) {
  preparePlayground(payload);
  openPlayground(newTab);
}
